<template>
	<div class="main">
		<ul id="dormitoryTypeNav" class="nav nav-tabs" role="tablist" v-show="isAdmin('stay')">
			<li class="" data-apply-type="N" role="presentation" v-if="normalIsOpen" >
				<a data-toggle="tab" @click="selectionDoemitoryType('N')">一般宿舍</a>
			</li>
			<li class="" data-apply-type="V" role="presentation" v-if="vacationIsOpen" >
				<a data-toggle="tab" @click="selectionDoemitoryType('V')">寒暑假宿舍</a>
			</li>
			<li class="" data-apply-type="S" role="presentation" v-if="specialIsOpen" >
				<a data-toggle="tab" @click="selectionDoemitoryType('S')">特殊原因宿舍</a>
			</li>
		</ul>
		<section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4" v-if="dormitoryType == 'N'">
								<label class="col-md-4">學期</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value" :selected="index == 0">{{year.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4" v-else>
								<label class="col-md-4">學年</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{year.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">學制</label>
								<div class="col-md-8">
									<select v-model="deptSsym" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(item, index) in ssymList" :key="index" :value="item.commCode">{{item.commValue}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">系科</label>
								<div class="col-md-8">
									<select v-model="deptCode" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(item, index) in deptList" :key="index" :value="item.commCode">{{item.commValue}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">年級</label>
								<div class="col-md-8">
									<select v-model="drade" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="d in 7" :key="d" :value="d">{{d}}年級</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">學生狀態</label>
								<div class="col-md-8">
									<select v-model="state" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(item, index) in stateList" :key="index" :value="item.commCode">{{item.commValue}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">學號</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="account" />
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">姓名</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="name" />
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">身分別</label>
								<div class="col-md-8">
									<select v-model.number="stuIdentity" class="form-control">
										<option :value="null">--請選擇--</option>
										<option v-for="(item, index) in identiList" :key="index" :value="item.commCode">{{item.commValue}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">宿舍</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="bedFloor" />
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">寢室</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="bedRoom" />
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-4 "></div>
						<div class="col-md-4 ">
							<div class="col-xs-5 col-md-4">
								<button type="button" class="btn btn-default btn-block" @click="clearSearchParam()">清除</button>
							</div>
							<div class="col-xs-2 col-md-4"></div>
							<div class="col-xs-5 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
						<div class="col-md-4 "></div>
					</div>
				</div>
			</div>
		</section>
		<div class="tab-content">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
				<div class="row form-group">
					<div class="col-md-12 text-right form-inline" v-if="isAdmin('stay')">
						<div class="col-md-6 text-left">
							</div>
						<div class="col-md-6 text-right">
							<button class="btn btn-default hidden-xs" @click="exportDoorplatePdf" :disabled="exportingDoorplate">{{ exportingDoorplate ? "門牌匯出中..." : "門牌" }}</button>
							<button class="btn btn-default btn-block visible-xs" @click="exportDoorplatePdf" :disabled="exportingDoorplate">{{ exportingDoorplate ? "門牌匯出中..." : "門牌" }}</button>
							<button class="btn btn-default hidden-xs" @click="exportFloorRosterPdf" :disabled="exportingFloorRoster">{{ exportingFloorRoster ? "樓層清冊匯出中..." : "樓層清冊" }}</button>
							<button class="btn btn-default btn-block visible-xs" @click="exportFloorRosterPdf" :disabled="exportingFloorRoster">{{ exportingFloorRoster ? "樓層清冊匯出中..." : "樓層清冊" }}</button>
							<button class="btn btn-danger hidden-xs" @click="exportExcel">資料匯出</button>
							<button class="btn btn-danger btn-block visible-xs" @click="exportExcel">資料匯出</button>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 form-group">
						<table class="table table-no-more table-bordered table-striped mb-none" style="width:100% !important;">
							<thead>
								<tr>
									<th class="text-center" style="width:10%">學期</th>
									<th class="text-center" style="width:15%">學制</th>
									<th class="text-center" style="width:20%">系科年級</th>
									<th class="text-center" style="width:10%">學號</th>
									<th class="text-center" style="width:10%">姓名</th>
									<th class="text-center" style="width:15%">宿舍床位</th>
									<th class="text-center" style="width:20%">電腦mac位置</th>
								</tr>
							</thead>
							<tbody v-for="(item, index) in roomApplyList.rows" :key="index">
								<tr>
									<td class="text-center" data-title="學期">{{item.smtr}}</td>
									<td class="text-center" data-title="學制">{{item.deptSsymStr}}</td>
									<td class="text-center" data-title="系科年級">{{item.deptCodeStr}}<br/>{{item.drade}}年{{item.dradeClass}}班</td>
									<td class="text-center" data-title="學號">{{item.account}}</td>
									<td class="text-center" data-title="姓名">{{item.name}}</td>
									<td class="text-center" data-title="宿舍床位" >
										<span v-if="item.bedRoom !== null">{{item.bedFloor}}-{{item.bedRoom}}-{{item.bed}}-{{item.bedCategory}}</span>
									</td>
									<td class="text-center" data-title="電腦mac位置" >
										<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" @click="gotoView('stay.intoRoomData', { dormitoryType: item.dormitoryType, smtr: item.smtr, idno: item.idno, account: item.account, id:item.id })">{{item.macAddr}}</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center">
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="floor-roster-render" v-if="floorRosterPages.length > 0">
			<div v-for="(pageItem, pageIndex) in floorRosterPages" :key="pageItem.key" ref="floorRosterPages" class="floor-roster-page">
				<div class="floor-roster-body">
					<table class="floor-roster-table">
						<thead>
							<tr>
								<th>宿舍名稱</th>
								<th>房間編號</th>
								<th>科系</th>
								<th>學號</th>
								<th>姓名</th>
								<th>照片</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in pageItem.rows" :key="getFloorRosterPhotoKey(item)">
								<td>{{ item.bedFloor || "" }}</td>
								<td>{{ item.bedRoom || "" }}</td>
								<td>{{ item.deptCodeStr || "" }}</td>
								<td>{{ item.account || "" }}</td>
								<td>{{ item.name || "" }}</td>
								<td class="floor-roster-photo-cell">
									<img v-if="getFloorRosterPhotoUrl(item)" :src="getFloorRosterPhotoUrl(item)" class="floor-roster-photo" alt="學生照片" @error="handleFloorRosterPhotoError(item)" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="floor-roster-footer">第 {{ pageIndex + 1 }} 頁</div>
			</div>
		</div>
	</div>
</template>
<script>
import html2canvas from "html2canvas";
import { PDFDocument } from "pdf-lib";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import "pdfjs-dist/legacy/build/pdf.worker.entry";
import { jsPDF } from "jspdf";
import doorplateTemplateManifest from "@/json/doorplate-template-manifest.json";

const DOORPLATE_TEMPLATE_FILES = [
	"1141元居10樓.pdf",
	"1141元居9樓.pdf",
	"1141誠堡10樓.pdf",
	"1141誠堡11樓.pdf",
	"1141誠堡2樓.pdf",
	"114誠堡12樓.pdf",
];

const DOORPLATE_CMAP_URL = "https://cdn.jsdelivr.net/npm/pdfjs-dist@2.16.105/cmaps/";
const DOORPLATE_FONT_FAMILY = '"PingFang TC", "Microsoft JhengHei", "細明體", sans-serif';
const DOORPLATE_TEXT_COLOR = "#4a4a4a";
const DOORPLATE_FALLBACK_SLOT_CENTER_X_RATIOS = {
	default: 0.89,
	2: 0.887,
	3: 0.893,
	4: 0.898,
};
const DOORPLATE_FALLBACK_SLOT_CENTER_Y_RATIOS = {
	2: [0.579, 0.213],
	3: [0.618, 0.371, 0.123],
	4: [0.698, 0.508, 0.319, 0.13],
};
const DOORPLATE_SLOT_LAYOUT_OVERRIDES = {
	default: {
		fontScale: 1.2,
		lineGapScale: 0.1,
	},
	2: {
		moveX: -55,
		moveY: -5,
		fontScale: 3.6,
	},
	3: {
		moveX: -60,
		moveY: -10,
		fontScale: 3,
	},
	4: {
		moveX: -40,
		moveY: 30,
		fontScale: 3.2,
	},
	6: {
		moveY: 45,
		moveX: -2,
		fontScale: 2.8,
		lineGapScale: 0.1,
	},
	8: {
		moveY: 45,
		moveX: 1,
		fontScale: 2.9,
		lineGapScale: 0.1,
	},
	10: {
		moveY: 32,
		moveX: 2,
		fontScale: 2.65,
		lineGapScale: 0.1,
	},
};

export default {
	data() {
		return {
			dormitoryType: "N",
			arimId: "",
			normalIsOpen: true,
			vacationIsOpen: true,
			specialIsOpen: true,
			isDefault: true,
			importExcelFile: "",
			accountType: "",
			quitProveView: true,
			roomApplyList: { rows: [] },
			quitProveFile: null,
			bed: "",
			bedList: [],
			account: "",
			name: "",
			smtr: "",
			idno: "",
			deptSsym: "",
			deptCode: "",
			drade: "",
			state: "",
			stuIdentity: null,
			deptList: [],
			stateList: [],
			identiList: [],
			apysList: [],
			ssymList: [],
			bedFloor:"",
			bedRoom:"",
			page: 1,
			totalPage: 1,
			exportingDoorplate: false,
			exportingFloorRoster: false,
			doorplateTemplates: null,
			floorRosterPages: [],
			floorRosterPhotoErrors: {},
			isOpenBillingInvoice:false,
			popupParam:{
				idno:"",
				account:"",
				smtr:"",
				dormitoryType:""
			},
		};
	},
	mounted() {
		let _this = this;
		if (this.sessionData == null) {
			_this.$router.replace({ path: "/" });
		}

		// 載入下拉選單資料
		const apiInit = "/api/Room/stayInit";
		this.$axios.post(apiInit).then(resp =>{
			_this.deptList = resp.data.data.deptList;
			_this.stateList = resp.data.data.stateList;
			_this.identiList = resp.data.data.identiList;
			_this.apysList = resp.data.data.apysList;
			_this.ssymList = resp.data.data.ssymList;
		});

    //套用查詢設定
    const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));

    if(storeQryParam != null) {
      this.dormitoryType = storeQryParam.dormitoryType;
      this.bedFloor = storeQryParam.bedFloor;
      this.bedRoom = storeQryParam.bedRoom;
      this.smtr = storeQryParam.smtr;
      this.account = storeQryParam.account;
      this.name = storeQryParam.name || "";
      this.deptSsym = storeQryParam.deptSsym || "";
      this.deptCode = storeQryParam.deptCode || "";
      this.drade = storeQryParam.drade || "";
      this.state = storeQryParam.state || "";
      this.stuIdentity = storeQryParam.stuIdentity || null;
    }
    const storePage = this.getStore(`${this.$route.name}.page`);
    if(storePage != null) {
      this.page = storePage;
    }

    switch (this.dormitoryType) {
      case "V":
        document.querySelector("[id='dormitoryTypeNav']").children[1].classList.add("active");
        break;
      case "S":
        document.querySelector("[id='dormitoryTypeNav']").children[2].classList.add("active");
        break;
      case "N":
      default:
        document.querySelector("[id='dormitoryTypeNav']").children[0].classList.add("active");
        break;
    }

		_this.selectionDoemitoryType(this.dormitoryType, false);
	},
	methods: {
		selectionDoemitoryType(dormitoryType, clearQueryParam = true) {
			this.dormitoryType = dormitoryType;
      if(clearQueryParam){
        this.bedFloor = "";
        this.bedRoom = "";
        this.account = "";
        this.name = "";
        this.deptSsym = "";
        this.deptCode = "";
        this.drade = "";
        this.state = "";
        this.stuIdentity = null;
        if(this.dormitoryType == "N"){
          this.smtr = this.nowSmtr;
        }else {
          this.smtr = `${this.nowSyear}`
        }
      } else {
        if(this.dormitoryType == "N" && (this.smtr.length != 4)){
          this.smtr = this.nowSmtr;
        }else if ((this.dormitoryType == "V" || this.dormitoryType == "S" ) && this.smtr.length != 3) {
          this.smtr = `${this.nowSyear}`
        }
      }
			this.loadGrid();
		},
		buildQueryParam() {
			return {
				dormitoryType: this.dormitoryType,
				smtr: this.smtr,
				account: this.account,
				name: this.name,
				deptSsym: this.deptSsym,
				deptCode: this.deptCode,
				drade: this.drade,
				state: this.state,
				stuIdentity: this.stuIdentity,
				applyStatus: "Y",
				bedFloor: this.bedFloor,
				bedRoom: this.bedRoom,
				qualification: "Q",
				writeOffStatus: "Y",
				isLeave: "N",
				quitProve: "N",
			};
		},
		loadGrid(){
			let qryParam = this.buildQueryParam();
			const api = "/api/Room/roomApplyList";
			let _this = this;
			this.$axios.post(api, JSON.stringify({
				model:qryParam,
				page: this.page,
				pageSize: 10,
				sortColumn:"BED_FLOOR, BED_ROOM, BED, BED_CATEGORY"
			})).then(resp => {
				_this.roomApplyList = resp.data.data;
				_this.totalPage = _this.roomApplyList.total;
				_this.page = _this.roomApplyList.page;
			});
		},
		setDoemitoryType(dormitoryType) {
			this.dormitoryType = dormitoryType;
		},
		updateGrid(page) {
			this.page = page;
			this.loadGrid();
		},

		exportExcel() {
			const api = "/api/Room/exportRoomData";
			this.$axios.post( api, JSON.stringify(this.buildQueryParam()), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "入宿資料_"+this.customFormatter(new Date())+".xlsx");
				document.body.appendChild(link);
				link.click();
			});
		},
		async exportDoorplatePdf() {
			if (this.exportingDoorplate) {
				return;
			}

			this.exportingDoorplate = true;

			try {
				const rows = await this.fetchDoorplateRows();
				if (rows.length === 0) {
					alert("查無符合條件的門牌資料");
					return;
				}

				const templates = await this.getDoorplateTemplates(true);
				const roomMap = this.buildDoorplateRoomMap(rows);
				const selectedTemplates = this.selectDoorplateTemplates(templates, roomMap);

				if (selectedTemplates.templates.length === 0) {
					alert("查無可套用的門牌模板");
					return;
				}

				if (selectedTemplates.unsupportedFloors.length > 0) {
					alert(`以下宿舍目前沒有門牌模板，已略過：${selectedTemplates.unsupportedFloors.join("、")}`);
				}

				const mergedPdf = await PDFDocument.create();
				const imageCache = {};

				for (const template of selectedTemplates.templates) {
					const pages = this.getDoorplatePagesForExport(template);
					if (pages.length === 0) {
						continue;
					}

					const copiedPages = await mergedPdf.copyPages(template.pdfDoc, pages.map(page => page.pageIndex));
					for (let index = 0; index < copiedPages.length; index++) {
						const copiedPage = copiedPages[index];
						const pageMeta = pages[index];
						mergedPdf.addPage(copiedPage);
						await this.drawDoorplatePage(mergedPdf, copiedPage, pageMeta, roomMap, imageCache);
					}
				}

				if (mergedPdf.getPageCount() === 0) {
					alert("查無符合條件的門牌頁面");
					return;
				}

				const pdfBytes = await mergedPdf.save();
				this.downloadDoorplatePdf(pdfBytes, `門牌_${this.customFormatter(new Date(), "YYYYMMDD")}.pdf`);
			} catch (error) {
				alert("門牌PDF匯出失敗，請稍後再試");
			} finally {
				this.exportingDoorplate = false;
			}
		},
		buildDoorplateQueryParam() {
			return {
				dormitoryType: this.dormitoryType,
				smtr: this.smtr,
				bedFloor: this.bedFloor,
				bedRoom: this.bedRoom,
				applyStatus: "Y",
				qualification: "Q",
				writeOffStatus: "Y",
				isLeave: "N",
				quitProve: "N",
			};
		},
		async fetchDoorplateRows() {
			const api = "/api/Room/roomApplyList";
			const pageSize = 500;
			let page = 1;
			let totalPage = 1;
			let rows = [];

			do {
				const resp = await this.$axios.post(api, JSON.stringify({
					model: this.buildDoorplateQueryParam(),
					page: page,
					pageSize: pageSize,
					sortColumn: "BED_FLOOR, BED_ROOM, BED"
				}));
				const grid = resp.data.data || {};
				totalPage = grid.total || 1;
				rows = rows.concat(grid.rows || []);
				page += 1;
			} while (page <= totalPage);

			return rows.sort((left, right) => this.compareFloorRosterRows(left, right));
		},
		async getDoorplateTemplates(forceReload = false) {
			if (!forceReload && this.doorplateTemplates) {
				return this.doorplateTemplates;
			}

			const templates = [];
			for (const fileName of DOORPLATE_TEMPLATE_FILES) {
				templates.push(await this.loadDoorplateTemplate(fileName));
			}

			this.doorplateTemplates = templates;
			return templates;
		},
		getDoorplateTemplateMapping(fileName) {
			return doorplateTemplateManifest.find(item => item.fileName === fileName) || null;
		},
		getDoorplateTemplatePageMapping(templateMapping, pageNumber) {
			if (!templateMapping || !Array.isArray(templateMapping.pages)) {
				return null;
			}

			return templateMapping.pages.find(item => item.page === pageNumber) || null;
		},
		getDoorplateTemplatePageSlotCount(pageMapping) {
			const slotCount = Number(pageMapping && pageMapping.slotCount);
			return Number.isInteger(slotCount) && slotCount > 0 ? slotCount : 0;
		},
		getDoorplateTemplatePageLayoutOverride(pageMapping) {
			if (!pageMapping || !pageMapping.layoutOverride || typeof pageMapping.layoutOverride !== "object") {
				return null;
			}

			return pageMapping.layoutOverride;
		},
		getDoorplateTemplatePageSlotLayoutOverrides(pageMapping) {
			if (!pageMapping || !pageMapping.slotLayoutOverrides || typeof pageMapping.slotLayoutOverrides !== "object") {
				return {};
			}

			return pageMapping.slotLayoutOverrides;
		},
		getDoorplateTemplateFileFloorLabel(fileName) {
			return (fileName || "")
				.replace(/^\d+/, "")
				.replace(/\.pdf$/i, "");
		},
		getDoorplateTemplateFloorKeys(templateMapping, fallbackTitle, fileName) {
			const aliases = [];

			if (templateMapping && Array.isArray(templateMapping.floorAliases)) {
				aliases.push(...templateMapping.floorAliases);
			}
			if (fallbackTitle) {
				aliases.push(fallbackTitle);
			}

			const fileFloorLabel = this.getDoorplateTemplateFileFloorLabel(fileName);
			if (fileFloorLabel) {
				aliases.push(fileFloorLabel);
			}

			return aliases
				.map(item => this.normalizeDoorplateFloorKey(item))
				.filter((item, index, array) => item && array.indexOf(item) === index);
		},
		resolveDoorplateSlotItems(slotItems, expectedSlotCount, pageViewport) {
			if (!expectedSlotCount) {
				return slotItems;
			}

			if (slotItems.length === expectedSlotCount) {
				return slotItems;
			}
			if (slotItems.length > expectedSlotCount) {
				return slotItems.slice(0, expectedSlotCount);
			}

			return this.buildDoorplateFallbackSlotItems(expectedSlotCount, pageViewport);
		},
		buildDoorplateFallbackSlotItems(slotCount, pageViewport) {
			if (!pageViewport || slotCount <= 0) {
				return [];
			}

			const centerXRatio = DOORPLATE_FALLBACK_SLOT_CENTER_X_RATIOS[slotCount] || DOORPLATE_FALLBACK_SLOT_CENTER_X_RATIOS.default;
			const centerYRatios = DOORPLATE_FALLBACK_SLOT_CENTER_Y_RATIOS[slotCount] || this.buildDoorplateFallbackCenterYRatios(slotCount);

			return centerYRatios.map((ratio, index) => ({
				str: String(index + 1).padStart(2, "0"),
				x: pageViewport.width * centerXRatio,
				y: pageViewport.height * ratio,
				width: 0,
				height: 0,
			}));
		},
		buildDoorplateFallbackCenterYRatios(slotCount) {
			if (slotCount <= 0) {
				return [];
			}
			if (slotCount === 1) {
				return [0.5];
			}

			const topRatio = slotCount <= 4 ? 0.7 : 0.74;
			const bottomRatio = 0.13;
			const step = (topRatio - bottomRatio) / (slotCount - 1);

			return Array.from({ length: slotCount }, (_, index) => Number((topRatio - (step * index)).toFixed(4)));
		},
		getDoorplateLayoutFactor(value) {
			const factor = Number(value);
			return Number.isFinite(factor) && factor > 0 ? factor : 1;
		},
		getDoorplateAutoHeightScale(layoutOverride) {
			if (!layoutOverride || typeof layoutOverride !== "object") {
				return 1;
			}

			const fontScale = this.getDoorplateLayoutFactor(layoutOverride.fontScale);
			const nameFontScale = this.getDoorplateLayoutFactor(layoutOverride.nameFontScale);
			const accountFontScale = this.getDoorplateLayoutFactor(layoutOverride.accountFontScale);
			const lineGapScale = this.getDoorplateLayoutFactor(layoutOverride.lineGapScale);
			const effectiveFontScale = Math.max(fontScale * nameFontScale, fontScale * accountFontScale);

			return Math.max(1, 1 + ((effectiveFontScale - 1) * 0.55) + ((lineGapScale - 1) * 0.45));
		},
		mergeDoorplateLayoutOverrides(...overrides) {
			return overrides.reduce((result, item) => {
				if (!item || typeof item !== "object") {
					return result;
				}

				result.moveX += Number(item.moveX) || 0;
				result.moveY += Number(item.moveY) || 0;
				result.widthScale *= this.getDoorplateLayoutFactor(item.widthScale);
				result.heightScale *= this.getDoorplateLayoutFactor(item.heightScale);
				result.fontScale *= this.getDoorplateLayoutFactor(item.fontScale);
				result.nameFontScale *= this.getDoorplateLayoutFactor(item.nameFontScale);
				result.accountFontScale *= this.getDoorplateLayoutFactor(item.accountFontScale);
				result.lineGapScale *= this.getDoorplateLayoutFactor(item.lineGapScale);
				result.columnGapOffset += Number(item.columnGapOffset) || 0;
				result.textOffsetY += Number(item.textOffsetY) || 0;
				if (typeof item.useUniformTextMetrics === "boolean") {
					result.useUniformTextMetrics = item.useUniformTextMetrics;
				}

				return result;
			}, {
				moveX: 0,
				moveY: 0,
				widthScale: 1,
				heightScale: 1,
				fontScale: 1,
				nameFontScale: 1,
				accountFontScale: 1,
				lineGapScale: 1,
				columnGapOffset: 0,
				textOffsetY: 0,
				useUniformTextMetrics: false,
			});
		},
		applyDoorplateLayoutOverride(layout, layoutOverride) {
			if (!layout || !layoutOverride) {
				return layout;
			}

			const nameFontScale = layoutOverride.fontScale * layoutOverride.nameFontScale;
			const accountFontScale = layoutOverride.fontScale * layoutOverride.accountFontScale;
			const autoHeightScale = this.getDoorplateAutoHeightScale(layoutOverride);

			return {
				...layout,
				centerXOffset: layout.centerXOffset + layoutOverride.moveX,
				centerYOffset: layout.centerYOffset - layoutOverride.moveY,
				blockWidth: this.clampDoorplateValue(Math.round(layout.blockWidth * layoutOverride.widthScale), 48, 320),
				blockHeight: this.clampDoorplateValue(Math.round(layout.blockHeight * layoutOverride.heightScale * autoHeightScale), 18, 160),
				nameFontSize: this.clampDoorplateValue(Math.round(layout.nameFontSize * nameFontScale), 8, 40),
				accountFontSize: this.clampDoorplateValue(Math.round(layout.accountFontSize * accountFontScale), 8, 34),
				lineGap: this.clampDoorplateValue(Math.round(layout.lineGap * layoutOverride.lineGapScale), 1, 16),
				columnGapOffset: Number(layout.columnGapOffset || 0) + Number(layoutOverride.columnGapOffset || 0),
				textOffsetY: Number(layout.textOffsetY || 0) + Number(layoutOverride.textOffsetY || 0),
				useUniformTextMetrics: Boolean(layoutOverride.useUniformTextMetrics),
			};
		},
		async loadDoorplateTemplate(fileName) {
			const templateMapping = this.getDoorplateTemplateMapping(fileName);
			const resp = await this.$axios.post(`/api/Common/downloadFile/${encodeURIComponent(fileName)}`, JSON.stringify({}), {
				headers: { "Content-Type": "application/json" },
				responseType: "arraybuffer"
			});

			const pdfBytes = new Uint8Array(resp.data);
			const pdfDoc = await PDFDocument.load(pdfBytes);
			const pdf = await pdfjsLib.getDocument({
				data: pdfBytes,
				cMapUrl: DOORPLATE_CMAP_URL,
				cMapPacked: true,
				isEvalSupported: false,
				useSystemFonts: true,
			}).promise;

			const pages = [];
			let floorTitle = "";

			for (let pageIndex = 1; pageIndex <= pdf.numPages; pageIndex++) {
				const page = await pdf.getPage(pageIndex);
				const viewport = page.getViewport({ scale: 1 });
				const textContent = await page.getTextContent();
				const items = textContent.items
					.map(item => ({
						str: (item.str || "").trim(),
						x: item.transform[4],
						y: item.transform[5],
						width: item.width || 0,
						height: item.height || item.transform[3] || 0,
					}))
					.filter(item => item.str !== "");

				if (!floorTitle) {
					const titleItem = this.findDoorplateTitleItem(items);
					floorTitle = titleItem ? titleItem.str : "";
				}

				const pageMapping = this.getDoorplateTemplatePageMapping(templateMapping, pageIndex);
				const roomCodeItem = this.findDoorplateRoomCodeItem(items);
				const slotItems = this.findDoorplateSlotItems(items);
				const expectedSlotCount = this.getDoorplateTemplatePageSlotCount(pageMapping);
				const pageLayoutOverride = this.getDoorplateTemplatePageLayoutOverride(pageMapping);
				const pageSlotLayoutOverrides = this.getDoorplateTemplatePageSlotLayoutOverrides(pageMapping);
				const resolvedSlotItems = this.resolveDoorplateSlotItems(slotItems, expectedSlotCount, viewport);
				const baseLayout = this.resolveDoorplateLayout(resolvedSlotItems, expectedSlotCount);
				const slotCount = expectedSlotCount || resolvedSlotItems.length;
				const layout = this.applyDoorplateLayoutOverride(
					baseLayout,
					this.mergeDoorplateLayoutOverrides(
						DOORPLATE_SLOT_LAYOUT_OVERRIDES.default,
						DOORPLATE_SLOT_LAYOUT_OVERRIDES[slotCount],
						pageLayoutOverride,
					),
				);
				const roomCode = pageMapping && pageMapping.roomCode ? pageMapping.roomCode : (roomCodeItem ? roomCodeItem.str : "");
				if (!roomCode || !layout || resolvedSlotItems.length === 0) {
					continue;
				}

				const floorKeys = this.getDoorplateTemplateFloorKeys(templateMapping, floorTitle, fileName);

				pages.push({
					pageIndex: pageIndex - 1,
					floorTitle: templateMapping && templateMapping.floorAliases && templateMapping.floorAliases.length > 0 ? templateMapping.floorAliases[0] : floorTitle,
					floorKey: floorKeys[0] || this.normalizeDoorplateFloorKey(floorTitle),
					floorKeys: floorKeys,
					roomCode: roomCode,
					roomKey: this.normalizeDoorplateRoomKey(roomCode),
					slotCount: slotCount,
					layoutKey: layout.key,
					slots: this.buildDoorplateSlots(resolvedSlotItems, layout, pageSlotLayoutOverrides),
				});
			}

			const templateFloorKeys = this.getDoorplateTemplateFloorKeys(templateMapping, floorTitle, fileName);

			return {
				fileName: fileName,
				floorTitle: templateMapping && templateMapping.floorAliases && templateMapping.floorAliases.length > 0 ? templateMapping.floorAliases[0] : floorTitle,
				floorKey: templateFloorKeys[0] || this.normalizeDoorplateFloorKey(floorTitle),
				floorKeys: templateFloorKeys,
				pdfDoc: pdfDoc,
				pages: pages,
			};
		},
		findDoorplateTitleItem(items) {
			return items.find(item => /^[^\s]+宿舍\d+F$/.test(item.str)) || null;
		},
		findDoorplateRoomCodeItem(items) {
			const candidates = items.filter(item => /^[A-Z]\d{5}$/.test(item.str));
			if (candidates.length === 0) {
				const sortedItems = [...items].sort((left, right) => {
					if (Math.abs(left.y - right.y) < 4) {
						return left.x - right.x;
					}

					return right.y - left.y;
				});

				for (let index = 0; index < sortedItems.length - 1; index++) {
					const left = sortedItems[index];
					const right = sortedItems[index + 1];
					if (!/^[A-Z]$/.test(left.str) || !/^\d{5}$/.test(right.str)) {
						continue;
					}
					if (Math.abs(left.y - right.y) > 4) {
						continue;
					}
					if (right.x < left.x || (right.x - left.x) > 80) {
						continue;
					}

					return {
						str: `${left.str}${right.str}`,
						x: left.x,
						y: Math.min(left.y, right.y),
						width: (right.x + right.width) - left.x,
						height: Math.max(left.height, right.height),
					};
				}

				return null;
			}

			return candidates.sort((left, right) => right.y - left.y)[0];
		},
		findDoorplateSlotItems(items) {
			return items
				.filter(item => /^(0[1-9]|10)$/.test(item.str))
				.sort((left, right) => parseInt(left.str, 10) - parseInt(right.str, 10));
		},
		resolveDoorplateLayout(slotItems, expectedSlotCount) {
			if (!slotItems || slotItems.length === 0) {
				return null;
			}

			const slotCount = expectedSlotCount || slotItems.length;

			const slotCenters = slotItems.map(item => ({
				centerX: item.x + (item.width / 2),
				centerY: item.y + (item.height / 2),
			}));
			const xClusters = this.clusterDoorplateAxis(slotCenters.map(item => item.centerX), 70);

			if (xClusters.length <= 1) {
				return this.buildVerticalDoorplateLayout(slotCenters, slotCount);
			}

			return this.buildGridDoorplateLayout(slotCenters, slotCount);
		},
		buildVerticalDoorplateLayout(slotCenters, slotCount) {
			const rowCenters = slotCenters.map(item => item.centerY).sort((left, right) => right - left);
			const rowGap = this.getDoorplateMinGap(rowCenters);
			const blockHeight = slotCount >= 6
				? this.clampDoorplateValue(Math.round((rowGap || 72) * 0.55), slotCount >= 10 ? 20 : slotCount >= 8 ? 24 : 30, slotCount >= 10 ? 30 : slotCount >= 8 ? 36 : 44)
				: this.clampDoorplateValue(Math.round((rowGap || 140) * 0.5), 56, 86);

			return {
				key: `vertical-${slotCount}`,
				blockWidth: slotCount >= 6 ? 230 : 260,
				blockHeight: blockHeight,
				centerXOffset: -175,
				centerYOffset: 12,
				nameFontSize: this.clampDoorplateValue(Math.round(blockHeight * 0.28), slotCount >= 6 ? 10 : 16, slotCount >= 10 ? 14 : slotCount >= 6 ? 18 : 24),
				accountFontSize: this.clampDoorplateValue(Math.round(blockHeight * 0.23), slotCount >= 6 ? 9 : 13, slotCount >= 10 ? 12 : slotCount >= 6 ? 15 : 20),
				lineGap: blockHeight >= 78 ? 8 : blockHeight >= 48 ? 6 : 3,
				textColor: DOORPLATE_TEXT_COLOR,
			};
		},
		buildGridDoorplateLayout(slotCenters, slotCount) {
			const columnCenters = this.clusterDoorplateAxis(slotCenters.map(item => item.centerX), 70).sort((left, right) => left - right);
			const rowCenters = this.clusterDoorplateAxis(slotCenters.map(item => item.centerY), 45).sort((left, right) => right - left);
			const columnGap = this.getDoorplateMinGap(columnCenters);
			const rowGap = this.getDoorplateMinGap(rowCenters);
			const blockWidth = slotCount >= 6
				? this.clampDoorplateValue(Math.round((columnGap || 180) * 0.72), slotCount >= 8 ? 90 : 100, slotCount >= 8 ? 120 : 132)
				: this.clampDoorplateValue(Math.round((columnGap || 180) * 0.72), 118, 160);
			const blockHeight = slotCount >= 6
				? this.clampDoorplateValue(Math.round((rowGap || 80) * 0.55), slotCount >= 8 ? 26 : 32, slotCount >= 8 ? 40 : 46)
				: this.clampDoorplateValue(Math.round((rowGap || 110) * 0.55), 44, 70);

			return {
				key: `grid-${slotCount}`,
				blockWidth: blockWidth,
				blockHeight: blockHeight,
				centerXOffset: 0,
				centerYOffset: -Math.round(Math.max(24, blockHeight * 0.58)),
				nameFontSize: this.clampDoorplateValue(Math.round(blockHeight * 0.27), slotCount >= 6 ? 9 : 12, slotCount >= 8 ? 13 : 16),
				accountFontSize: this.clampDoorplateValue(Math.round(blockHeight * 0.22), slotCount >= 6 ? 8 : 10, slotCount >= 8 ? 11 : 13),
				lineGap: blockHeight >= 60 ? 3 : blockHeight >= 40 ? 2 : 1,
				textColor: DOORPLATE_TEXT_COLOR,
			};
		},
		clusterDoorplateAxis(values, tolerance) {
			const sortedValues = [...values].sort((left, right) => left - right);
			if (sortedValues.length === 0) {
				return [];
			}

			const groups = [[sortedValues[0]]];
			for (let index = 1; index < sortedValues.length; index++) {
				const value = sortedValues[index];
				const lastGroup = groups[groups.length - 1];
				const lastAverage = lastGroup.reduce((sum, item) => sum + item, 0) / lastGroup.length;

				if (Math.abs(value - lastAverage) <= tolerance) {
					lastGroup.push(value);
				} else {
					groups.push([value]);
				}
			}

			return groups.map(group => group.reduce((sum, item) => sum + item, 0) / group.length);
		},
		getDoorplateMinGap(values) {
			if (!values || values.length < 2) {
				return 0;
			}

			const gaps = [];
			for (let index = 1; index < values.length; index++) {
				const gap = Math.abs(values[index] - values[index - 1]);
				if (gap > 1) {
					gaps.push(gap);
				}
			}

			return gaps.length > 0 ? Math.min(...gaps) : 0;
		},
		clampDoorplateValue(value, min, max) {
			return Math.max(min, Math.min(max, value));
		},
		buildDoorplateSlots(slotItems, layout, slotLayoutOverrides = {}) {
			const columnCenters = this.clusterDoorplateAxis(slotItems.map(item => item.x + (item.width / 2)), 70).sort((left, right) => left - right);
			const columnMidpoint = columnCenters.length >= 2
				? (columnCenters[0] + columnCenters[columnCenters.length - 1]) / 2
				: 0;
			const columnGapOffset = Number(layout.columnGapOffset) || 0;

			return slotItems.map(item => {
				const slotKey = this.normalizeDoorplateSlotKey(item.str);
				const slotLayoutOverride = slotLayoutOverrides && typeof slotLayoutOverrides[slotKey] === "object"
					? slotLayoutOverrides[slotKey]
					: {};

				return {
					slotKey: slotKey,
					centerX: item.x + (item.width / 2) + layout.centerXOffset + (
					columnCenters.length >= 2 && columnGapOffset !== 0
						? ((item.x + (item.width / 2)) < columnMidpoint ? -(columnGapOffset / 2) : (columnGapOffset / 2))
						: 0
					),
					centerY: item.y + (item.height / 2) + layout.centerYOffset - (Number(slotLayoutOverride.moveY) || 0),
					width: layout.blockWidth,
					height: layout.blockHeight,
					layoutKey: layout.key,
					nameFontSize: layout.nameFontSize,
					accountFontSize: layout.accountFontSize,
					lineGap: layout.lineGap,
					textOffsetY: layout.textOffsetY,
					useUniformTextMetrics: layout.useUniformTextMetrics,
					textColor: layout.textColor,
				};
			});
		},
		buildDoorplateRoomMap(rows) {
			const roomMap = {};

			rows.forEach(item => {
				const floorKey = this.normalizeDoorplateFloorKey(item.bedFloor);
				const roomKey = this.normalizeDoorplateRoomKey(item.bedRoom);
				const slotKey = this.normalizeDoorplateSlotKey(item.bed);
				if (!floorKey || !roomKey || !slotKey) {
					return;
				}

				if (!roomMap[floorKey]) {
					roomMap[floorKey] = {};
				}
				if (!roomMap[floorKey][roomKey]) {
					roomMap[floorKey][roomKey] = {};
				}
				roomMap[floorKey][roomKey][slotKey] = item;
			});

			return roomMap;
		},
		selectDoorplateTemplates(templates, roomMap) {
			const floorKeys = Object.keys(roomMap);
			return {
				templates: templates.filter(template => (template.floorKeys || [template.floorKey]).some(item => floorKeys.includes(item))),
				unsupportedFloors: floorKeys.filter(floorKey => !templates.some(template => (template.floorKeys || [template.floorKey]).includes(floorKey))),
			};
		},
		getDoorplatePagesForExport(template) {
			const roomFilter = this.normalizeDoorplateRoomKey(this.bedRoom);
			if (!roomFilter) {
				return template.pages;
			}

			return template.pages.filter(page => page.roomKey === roomFilter);
		},
		async drawDoorplatePage(pdfDoc, page, pageMeta, roomMap, imageCache) {
			const matchedFloorKey = (pageMeta.floorKeys || [pageMeta.floorKey]).find(item => roomMap[item] && roomMap[item][pageMeta.roomKey]);
			const roomSlots = matchedFloorKey && roomMap[matchedFloorKey] && roomMap[matchedFloorKey][pageMeta.roomKey]
				? roomMap[matchedFloorKey][pageMeta.roomKey]
				: {};

			for (const slot of pageMeta.slots) {
				const occupant = roomSlots[slot.slotKey];
				if (!occupant) {
					continue;
				}

				const imageKey = [
					slot.layoutKey,
					Math.round(slot.width),
					Math.round(slot.height),
					slot.nameFontSize,
					slot.accountFontSize,
					occupant.name || "",
					occupant.account || "",
				].join(":");
				if (!imageCache[imageKey]) {
					imageCache[imageKey] = await this.createDoorplateTextImage(pdfDoc, occupant, slot);
				}

				page.drawImage(imageCache[imageKey], {
					x: slot.centerX - (slot.width / 2),
					y: slot.centerY - (slot.height / 2),
					width: slot.width,
					height: slot.height,
				});
			}
		},
		async createDoorplateTextImage(pdfDoc, occupant, layout) {
			const blockWidth = Number(layout.width || layout.blockWidth);
			const blockHeight = Number(layout.height || layout.blockHeight);
			if (!Number.isFinite(blockWidth) || !Number.isFinite(blockHeight) || blockWidth <= 0 || blockHeight <= 0) {
				throw new Error(`invalid doorplate layout size: ${blockWidth}x${blockHeight}`);
			}

			const scale = 2;
			const canvas = document.createElement("canvas");
			canvas.width = Math.ceil(blockWidth * scale);
			canvas.height = Math.ceil(blockHeight * scale);
			const context = canvas.getContext("2d");
			if (!context) {
				throw new Error("doorplate canvas not available");
			}

			context.scale(scale, scale);
			context.clearRect(0, 0, blockWidth, blockHeight);
			context.fillStyle = layout.textColor;
			context.textAlign = "center";
			context.textBaseline = "top";

			const nameText = occupant.name || "";
			const accountText = occupant.account || "";
			const textLayout = this.fitDoorplateTextLayout(context, {
				nameText,
				accountText,
				blockWidth,
				blockHeight,
				nameFontSize: layout.nameFontSize,
				accountFontSize: layout.accountFontSize,
				lineGap: layout.lineGap,
				useUniformTextMetrics: Boolean(layout.useUniformTextMetrics),
			});

			const topOffset = Math.max(0, (blockHeight - textLayout.totalHeight) / 2) + (Number(layout.textOffsetY) || 0);

			context.font = `${textLayout.nameFontSize}px ${DOORPLATE_FONT_FAMILY}`;
			context.fillText(nameText, blockWidth / 2, topOffset);

			context.font = `${textLayout.accountFontSize}px ${DOORPLATE_FONT_FAMILY}`;
			context.fillText(accountText, blockWidth / 2, topOffset + textLayout.nameHeight + textLayout.lineGap);

			const pngBytes = await this.getDoorplateCanvasPngBytes(canvas);
			return pdfDoc.embedPng(pngBytes);
		},
		fitDoorplateTextLayout(context, { nameText, accountText, blockWidth, blockHeight, nameFontSize, accountFontSize, lineGap, useUniformTextMetrics = false }) {
			const initialNameFontSize = this.fitDoorplateFontSize(context, nameText, blockWidth - 16, nameFontSize, 10);
			const initialAccountFontSize = this.fitDoorplateFontSize(context, accountText, blockWidth - 16, accountFontSize, 10);
			const initialLineGap = Math.max(2, Number(lineGap) || 0);
			let nextNameFontSize = initialNameFontSize;
			let nextAccountFontSize = initialAccountFontSize;
			let nextLineGap = initialLineGap;
			const verticalPadding = this.getDoorplateTextVerticalPadding(blockHeight);
			const availableHeight = Math.max(0, blockHeight - (verticalPadding * 2));
			let nameHeight = 0;
			let accountHeight = 0;
			let contentHeight = 0;
			const preferredMinNameFontSize = Math.max(10, Math.floor(initialNameFontSize * 0.92));
			const preferredMinAccountFontSize = Math.max(10, Math.floor(initialAccountFontSize * 0.92));
			const hardMinFontSize = 8;
			const preferredMinLineGap = Math.max(1, Math.floor(initialLineGap * 0.9));
			const minLineGap = 1;

			for (let attempt = 0; attempt < 24; attempt++) {
				nameHeight = this.measureDoorplateTextHeight(context, nameText, nextNameFontSize, useUniformTextMetrics);
				accountHeight = this.measureDoorplateTextHeight(context, accountText, nextAccountFontSize, useUniformTextMetrics);
				contentHeight = nameHeight + accountHeight + nextLineGap;

				if (contentHeight <= availableHeight) {
					break;
				}

				let changed = false;
				if (nextLineGap > preferredMinLineGap) {
					nextLineGap -= 1;
					changed = true;
				}
				if (!changed && nextNameFontSize > preferredMinNameFontSize) {
					nextNameFontSize -= 1;
					changed = true;
				}
				if (!changed && nextAccountFontSize > preferredMinAccountFontSize) {
					nextAccountFontSize -= 1;
					changed = true;
				}
				if (!changed && nextLineGap > minLineGap) {
					nextLineGap -= 1;
					changed = true;
				}
				if (!changed && nextNameFontSize > hardMinFontSize) {
					nextNameFontSize -= 1;
					changed = true;
				}
				if (!changed && nextAccountFontSize > hardMinFontSize) {
					nextAccountFontSize -= 1;
					changed = true;
				}

				if (!changed) {
					break;
				}
			}

			nameHeight = this.measureDoorplateTextHeight(context, nameText, nextNameFontSize, useUniformTextMetrics);
			accountHeight = this.measureDoorplateTextHeight(context, accountText, nextAccountFontSize, useUniformTextMetrics);
			contentHeight = nameHeight + accountHeight + nextLineGap;

			return {
				nameFontSize: nextNameFontSize,
				accountFontSize: nextAccountFontSize,
				lineGap: nextLineGap,
				verticalPadding,
				nameHeight,
				accountHeight,
				contentHeight,
				totalHeight: contentHeight + (verticalPadding * 2),
			};
		},
		getDoorplateTextVerticalPadding(blockHeight) {
			return Math.max(3, Math.round(blockHeight * 0.08));
		},
		measureDoorplateTextHeight(context, text, fontSize, useUniformTextMetrics = false) {
			const sampleText = useUniformTextMetrics ? "門牌123456789" : (text || "Ag");
			context.font = `${fontSize}px ${DOORPLATE_FONT_FAMILY}`;
			const metrics = context.measureText(sampleText);
			const ascent = Number(metrics.fontBoundingBoxAscent)
				|| (useUniformTextMetrics ? 0 : Number(metrics.actualBoundingBoxAscent))
				|| Math.ceil(fontSize * 0.9);
			const descent = Number(metrics.fontBoundingBoxDescent)
				|| (useUniformTextMetrics ? 0 : Number(metrics.actualBoundingBoxDescent))
				|| Math.ceil(fontSize * 0.32);

			return Math.ceil(ascent + descent);
		},
		async getDoorplateCanvasPngBytes(canvas) {
			const pngBlob = await this.getDoorplateCanvasBlob(canvas, "image/png");
			if (pngBlob) {
				const pngBytes = new Uint8Array(await pngBlob.arrayBuffer());
				if (this.isDoorplatePngBytes(pngBytes)) {
					return pngBytes;
				}
			}

			const dataUrl = canvas.toDataURL("image/png");
			const pngBytes = this.decodeDoorplateDataUrl(dataUrl);
			if (!this.isDoorplatePngBytes(pngBytes)) {
				throw new Error(`doorplate canvas did not produce a PNG image: ${dataUrl.slice(0, 32)}`);
			}

			return pngBytes;
		},
		getDoorplateCanvasBlob(canvas, mimeType) {
			return new Promise(resolve => {
				if (typeof canvas.toBlob !== "function") {
					resolve(null);
					return;
				}

				canvas.toBlob(blob => resolve(blob), mimeType);
			});
		},
		decodeDoorplateDataUrl(dataUrl) {
			if (!dataUrl || dataUrl.indexOf(",") === -1) {
				return new Uint8Array();
			}

			const base64 = dataUrl.split(",", 2)[1] || "";
			if (!base64) {
				return new Uint8Array();
			}

			const binary = window.atob(base64);
			const bytes = new Uint8Array(binary.length);
			for (let index = 0; index < binary.length; index++) {
				bytes[index] = binary.charCodeAt(index);
			}

			return bytes;
		},
		isDoorplatePngBytes(bytes) {
			const pngSignature = [137, 80, 78, 71, 13, 10, 26, 10];
			if (!bytes || bytes.length < pngSignature.length) {
				return false;
			}

			return pngSignature.every((value, index) => bytes[index] === value);
		},
		fitDoorplateFontSize(context, text, maxWidth, preferredSize, minSize) {
			if (!text) {
				return preferredSize;
			}

			for (let fontSize = preferredSize; fontSize >= minSize; fontSize--) {
				context.font = `${fontSize}px ${DOORPLATE_FONT_FAMILY}`;
				if (context.measureText(text).width <= maxWidth) {
					return fontSize;
				}
			}

			return minSize;
		},
		downloadDoorplatePdf(pdfBytes, fileName) {
			const blob = new Blob([pdfBytes], { type: "application/pdf" });
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			window.URL.revokeObjectURL(url);
			link.remove();
		},
		normalizeDoorplateFloorKey(value) {
			const normalizedValue = this.normalizeFloorRosterValue(value)
				.replace(/\s+/g, "")
				.replace(/城堡/g, "誠堡");
			const floorMatch = normalizedValue.match(/([^\d]+?)(\d+)(?:F|樓)?$/i);

			if (floorMatch) {
				return `${floorMatch[1].replace(/宿舍/g, "")}${floorMatch[2]}`;
			}

			return normalizedValue
				.replace(/宿舍/g, "")
				.replace(/樓/gi, "")
				.replace(/F/gi, "");
		},
		normalizeDoorplateRoomKey(value) {
			const digits = this.normalizeFloorRosterValue(value).replace(/\D/g, "");
			if (!digits) {
				return "";
			}

			return digits.slice(-4).padStart(4, "0");
		},
		normalizeDoorplateSlotKey(value) {
			const digits = this.normalizeFloorRosterValue(value).replace(/\D/g, "");
			if (!digits) {
				return "";
			}

			return digits.padStart(2, "0");
		},
		async exportFloorRosterPdf() {
			if (this.exportingFloorRoster) {
				return;
			}

			this.exportingFloorRoster = true;
			this.floorRosterPages = [];
			this.floorRosterPhotoErrors = {};

			try {
				const rows = await this.fetchFloorRosterRows();
				if (rows.length === 0) {
					alert("查無符合查詢條件的樓層清冊資料");
					return;
				}

				this.floorRosterPages = this.buildFloorRosterPages(rows);
				await this.$nextTick();
				await this.waitForFloorRosterRender();
				await this.waitForFloorRosterAssets();
				await this.waitForFloorRosterRender();

				const pageElements = Array.isArray(this.$refs.floorRosterPages)
					? this.$refs.floorRosterPages
					: (this.$refs.floorRosterPages ? [this.$refs.floorRosterPages] : []);

				if (pageElements.length === 0) {
					throw new Error("floor roster pages not rendered");
				}

				const pdf = new jsPDF({
					orientation: "portrait",
					unit: "mm",
					format: "a4",
					compress: true,
				});

				for (let index = 0; index < pageElements.length; index++) {
					const canvas = await html2canvas(pageElements[index], {
						scale: 2,
						useCORS: true,
						backgroundColor: "#ffffff",
					});
					const imgData = canvas.toDataURL("image/jpeg", 0.92);
					if (index > 0) {
						pdf.addPage("a4", "portrait");
					}
					pdf.addImage(imgData, "JPEG", 0, 0, 210, 297);
				}

				pdf.save(`樓層清冊_${this.customFormatter(new Date(), "YYYYMMDD")}.pdf`);
			} catch (error) {
				alert("樓層清冊匯出失敗，請稍後再試");
			} finally {
				this.exportingFloorRoster = false;
				this.floorRosterPages = [];
			}
		},
		async fetchFloorRosterRows() {
			const api = "/api/Room/roomApplyList";
			const pageSize = 500;
			let page = 1;
			let totalPage = 1;
			let rows = [];

			do {
				const resp = await this.$axios.post(api, JSON.stringify({
					model: this.buildQueryParam(),
					page: page,
					pageSize: pageSize,
					sortColumn: "BED_FLOOR, BED_ROOM"
				}));
				const grid = resp.data.data || {};
				totalPage = grid.total || 1;
				rows = rows.concat(grid.rows || []);
				page += 1;
			} while (page <= totalPage);

			return rows.sort((left, right) => this.compareFloorRosterRows(left, right));
		},
		compareFloorRosterRows(left, right) {
			const floorCompare = this.normalizeFloorRosterValue(left.bedFloor).localeCompare(this.normalizeFloorRosterValue(right.bedFloor), "zh-Hant", { numeric: true, sensitivity: "base" });
			if (floorCompare !== 0) {
				return floorCompare;
			}

			const roomCompare = this.normalizeFloorRosterValue(left.bedRoom).localeCompare(this.normalizeFloorRosterValue(right.bedRoom), "zh-Hant", { numeric: true, sensitivity: "base" });
			if (roomCompare !== 0) {
				return roomCompare;
			}

			const bedCompare = this.normalizeFloorRosterValue(left.bed).localeCompare(this.normalizeFloorRosterValue(right.bed), "zh-Hant", { numeric: true, sensitivity: "base" });
			if (bedCompare !== 0) {
				return bedCompare;
			}

			return this.normalizeFloorRosterValue(left.account).localeCompare(this.normalizeFloorRosterValue(right.account), "zh-Hant", { numeric: true, sensitivity: "base" });
		},
		normalizeFloorRosterValue(value) {
			return value == null ? "" : `${value}`.trim();
		},
		buildFloorRosterPages(rows) {
			const pageSize = 8;
			const pages = [];
			for (let start = 0; start < rows.length; start += pageSize) {
				pages.push({
					key: `page-${start}`,
					rows: rows.slice(start, start + pageSize),
				});
			}

			return pages;
		},
		waitForFloorRosterRender() {
			return new Promise(resolve => {
				requestAnimationFrame(() => {
					requestAnimationFrame(resolve);
				});
			});
		},
		async waitForFloorRosterAssets() {
			const pageElements = Array.isArray(this.$refs.floorRosterPages)
				? this.$refs.floorRosterPages
				: (this.$refs.floorRosterPages ? [this.$refs.floorRosterPages] : []);

			const imageElements = pageElements.reduce((result, pageElement) => {
				return result.concat(Array.from(pageElement.querySelectorAll("img")));
			}, []);

			await Promise.all(imageElements.map(imageElement => {
				if (imageElement.complete) {
					return Promise.resolve();
				}

				return new Promise(resolve => {
					const done = () => {
						imageElement.removeEventListener("load", done);
						imageElement.removeEventListener("error", done);
						resolve();
					};
					imageElement.addEventListener("load", done);
					imageElement.addEventListener("error", done);
				});
			}));

			if (document.fonts && document.fonts.ready) {
				await document.fonts.ready.catch(() => undefined);
			}
		},
		getFloorRosterPhotoKey(item) {
			return item.id || `${item.account}-${item.bedFloor || ""}-${item.bedRoom || ""}`;
		},
		handleFloorRosterPhotoError(item) {
			this.$set(this.floorRosterPhotoErrors, this.getFloorRosterPhotoKey(item), true);
		},
		isValidPreviewExt(filePath) {
			if (filePath != null && filePath !== "") {
				const ext = filePath.substring(filePath.lastIndexOf(".") + 1).toLowerCase();
				return ext === "jpg" || ext === "jpeg" || ext === "png";
			}
			return false;
		},
		getPreviewUrl(filePath) {
			let url = "";
			if (this.isValidPreviewExt(filePath)) {
				url = "/upload/" + filePath;
			}
			return url;
		},
		getFloorRosterPhotoUrl(item) {
			const photoKey = this.getFloorRosterPhotoKey(item);
			if (this.floorRosterPhotoErrors[photoKey]) {
				return "";
			}
			return this.getPreviewUrl(item.stuPhoto);
		},

		isIntoRoom(item){
			return this.nowSmtr == item.smtr && item.dormitoryType == this.dormitoryType && item.writeOffStatus == "Y";
		},
		getDormitoryTypeStr(dormitoryType){
			let str = "";
			if(dormitoryType == "N"){
				str = "一般宿舍";
			}else if(dormitoryType == "S"){
				str = "特殊宿舍";
			}else if(dormitoryType == "V"){
				str = "寒暑假宿舍";
			}
			return str;
		},
		selectYear(){
			let smtrArray = [];
			let nowYear = (new Date().getFullYear() - 1911);
			let nowMonth = new Date().getMonth() + 1;
			if(nowMonth < 8){
				nowYear = nowYear-1;
			}
			for(let y = nowYear; y > 107 ; y--){
				if(this.dormitoryType == "N"){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
					smtrArray.push({text:y+"年第一學期",value:y+"1"});
				}else{
					smtrArray.push({text:y+"年",value:`${y}`});
				}
			}
			return smtrArray;
		},
		clearSearchParam(){
			this.smtr = "";
			this.account = "";
			this.name = "";
			this.deptSsym = "";
			this.deptCode = "";
			this.drade = "";
			this.state = "";
			this.stuIdentity = null;
			this.bedFloor = "";
			this.bedRoom = "";
			this.removeStore(`${this.$route.name}.qryParam`);
			this.removeStore(`${this.$route.name}.page`);
		},
	},
	computed: {
		isDataExists() {
			let result = false;
			if (this.roomApplyList.rows && this.roomApplyList.rows.length > 0) {
				result = true;
			}
			return result;
		}
  },
  beforeRouteLeave(to, from, next) {
    //保留查詢設定
    if(to.name === "stay.intoRoomData") {
      this.setStore(`${this.$route.name}.qryParam`, {
        dormitoryType: this.dormitoryType,
        smtr: this.smtr,
        account: this.account,
        name: this.name,
        deptSsym: this.deptSsym,
        deptCode: this.deptCode,
        drade: this.drade,
        state: this.state,
        stuIdentity: this.stuIdentity,
        bedFloor :this.bedFloor,
        bedRoom: this.bedRoom
      });
      this.setStore(`${this.$route.name}.page`, this.page);
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }
    this.removeStore(this.$route.name);
    next();
  }
};
</script>
<style scoped>
.floor-roster-render {
	position: fixed;
	left: -20000px;
	top: 0;
	z-index: -1;
	background: #ffffff;
}

.floor-roster-page {
	width: 794px;
	height: 1123px;
	padding: 28px 22px 24px;
	box-sizing: border-box;
	background: #ffffff;
	color: #111111;
	display: flex;
	flex-direction: column;
	font-family: "PingFang TC", "Microsoft JhengHei", sans-serif;
}

.floor-roster-body {
	flex: 1;
	display: block;
}

.floor-roster-table {
	width: 100%;
	border-collapse: collapse;
	table-layout: fixed;
	font-size: 14px;
}

.floor-roster-table th,
.floor-roster-table td {
	border: 1px solid #444444;
	padding: 8px 6px;
	text-align: center;
	vertical-align: middle;
	word-break: break-word;
}

.floor-roster-table th {
	background: #f2f2f2;
	font-weight: 700;
	font-size: 15px;
}

.floor-roster-table td {
	height: 120px;
}

.floor-roster-photo-cell {
	padding: 4px;
	width: 110px;
}

.floor-roster-photo {
	width: 100%;
	height: 110px;
	object-fit: cover;
	border: 1px solid #999999;
	display: block;
}

.floor-roster-footer {
	margin-top: 8px;
	text-align: right;
	font-size: 12px;
	color: #555555;
}
</style>
